import React from 'react'

function Earnings({meta}) {
  return (
    <div>Earnings</div>
  )
}

export default Earnings